import { render, staticRenderFns } from "./EventDataSelect.vue?vue&type=template&id=377bd368&scoped=true"
import script from "./EventDataSelect.vue?vue&type=script&lang=js"
export * from "./EventDataSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377bd368",
  null
  
)

export default component.exports